module.exports = __webpack_public_path__ + "media/images/first-championship-mobile-bf42f10fbf19d25f344524253c95c06a.jpg";